import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";
import { Reveal } from "@/components/bits/Reveal";
import { HandNote, Tape } from "@/components/bits/Sticker";

const BG = { yellow: "var(--yellow)", pink: "var(--pink)", blue: "var(--blue)", green: "var(--green)" };

export const Manifesto = () => (
  <section className="relative max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-32" data-testid="manifesto-section">
    <Reveal className="flex flex-col md:flex-row md:items-end gap-4 md:gap-8 mb-16">
      <h2 className="pixel-title text-5xl sm:text-6xl md:text-8xl">Field Notes</h2>
      <HandNote className="text-2xl md:text-3xl -rotate-2 md:mb-3">How I see it</HandNote>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
      {MANIFESTO.map((m, i) => (
        <motion.article
          key={m.n}
          data-testid={`manifesto-${m.n}`}
          className="relative bg-white border-[1.5px] border-[var(--ink)] p-7 md:p-10 hard-shadow"
          initial={{ opacity: 0, y: 40, rotate: i % 2 ? 1.5 : -1.5 }}
          whileInView={{ opacity: 1, y: 0, rotate: i % 2 ? 0.8 : -0.8 }}
          whileHover={{ rotate: 0, y: -6 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
        >
          <Tape rotate={i % 2 ? 6 : -6} className="-top-3 left-1/2 -translate-x-1/2" color={["", "pink", "blue", "green"][i]} />
          <div className="flex items-start justify-between gap-6">
            <span className="pixel-title text-6xl md:text-7xl leading-none" style={{ color: BG[m.color], WebkitTextStroke: "1.5px var(--ink)" }}>
              {m.n}
            </span>
          </div>
          <h3 className="mt-6 font-body font-bold text-xl md:text-2xl tracking-tight leading-snug">{m.title}</h3>
          <p className="mt-4 font-hand text-2xl leading-snug text-[var(--ink-60)]">{m.body}</p>
        </motion.article>
      ))}
    </div>
  </section>
);
